import React, { Component } from 'react';
import SampleGradingForm from './SampleGradingForm.js';
import AddNewCuppingSessionForm from './AddNewCuppingSessionForm.js';
import Modal from './Modal.js';

const initGrades = {
  fragrance: 7.50,
  flavor: 7.50,
  aftertaste: 7.50,
  acidity: 7.50,
  body: 7.50,
  balance: 7.50,
  overall: 7.50,
  uniformity: 10,
  cleancup: 10,
  sweetness: 10,
  defects: 0
};

class SamplesGrid extends Component {
  constructor(props) {
    super(props);


    this.state = {
      showInfo: false,
      showModal: false,
      currentItem: 0,
      unsavedChanges: {}
    };

    this.toggleContractInfo = this.toggleContractInfo.bind(this);
    this.createNewCuppingSession = this.createNewCuppingSession.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSaveSession = this.handleSaveSession.bind(this);
    this.initSampleNotes = this.initSampleNotes.bind(this);
    this.storeUnsavedChanges = this.storeUnsavedChanges.bind(this);
    this.storeUnsavedNotes = this.storeUnsavedNotes.bind(this);
    this.saveToDb = this.saveToDb.bind(this);
    //this.handleTransaction = this.handleTransaction.bind(this);
  }

  toggleContractInfo(contractIndex) {

    if (!this.state.showInfo || this.state.currentItem !== contractIndex) {
      this.setState({
        showInfo: true,
        currentItem: contractIndex
      });
      console.log(contractIndex);
      console.log(this.state.currentItem);
      console.log(this.state.unsavedChanges);
      console.log(this.state.queryData[contractIndex]);
      console.log(this.state.unsavedChanges[this.state.queryData[this.state.currentItem].id]);
      console.log(this.state.unsavedChanges[this.state.queryData[this.state.currentItem].id].fragrance);
      console.log(this.state.unsavedChanges[this.state.queryData[this.state.currentItem].id]);
    } else {
        this.setState({
        showInfo: false//,
        //currentItem: 0
      })
    }
  }

  handleSaveSession(){
    this.setState({
      showModal: false
    });
  }

  createNewCuppingSession() {
    this.setState({
      showModal: true
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false
    });
  }

  componentDidMount() {
    this.props.dbRef.orderBy("name").onSnapshot((querySnapshot) => {
      console.log('QuerySnapshot');
      console.log(querySnapshot.docs);
      this.setState({
        queryData: querySnapshot.docs
      })
      this.initSampleNotes(this.state.queryData);
      console.log("Called initSampleNotes");
    });

  }

  initSampleNotes(queryData) {
    let notesKeys = [
      'fragranceNotes',
      'flavorNotes',
      'aftertasteNotes',
      'acidityNotes',
      'bodyNotes',
      'obs'
    ];
    var tempUnsavedChanges = this.state.unsavedChanges;
    for (let i = 0; i < queryData.length; i++) {
      if (!this.state.unsavedChanges[queryData[i].id]) {
        tempUnsavedChanges[queryData[i].id] = {};
        tempUnsavedChanges[queryData[i].id].grades = {};
        tempUnsavedChanges[queryData[i].id].notes = {};
        if (queryData[i].data().grades) {
          let gradeKeys = Object.keys(initGrades);
          for (let j = 0; j < gradeKeys.length; j++) {
            if (queryData[i].data().grades[gradeKeys[j]]) {
              tempUnsavedChanges[queryData[i].id].grades[gradeKeys[j]] = queryData[i].data().grades[gradeKeys[j]];
            } else {
              tempUnsavedChanges[queryData[i].id].grades[gradeKeys[j]] = initGrades[gradeKeys[j]];
            }
          }
        } else {
          //tempUnsavedChanges[queryData[i].id] = initGrades;
          tempUnsavedChanges[queryData[i].id].grades = {
            fragrance: 7.50,
            flavor: 7.50,
            aftertaste: 7.50,
            acidity: 7.50,
            body: 7.50,
            balance: 7.50,
            overall: 7.50,
            uniformity: 10,
            cleancup: 10,
            sweetness: 10,
            defects: 0
          };
        }
        if (queryData[i].data().notes) {
          for (let j = 0; j < notesKeys.length; j++) {
            if (queryData[i].data().notes[notesKeys[j]]) {
              tempUnsavedChanges[queryData[i].id].notes[notesKeys[j]] = queryData[i].data().notes[notesKeys[j]];
            } /*else {
              if (notesKeys[j] == 'obs') {
                tempUnsavedChanges[queryData[i].id].notes[notesKeys[j]] = "";
                console.log('Init notes obs for: ',queryData[i].id);
              }
            }*/
          }
        } /*else {
          console.log('Init notes obs when !queryData.notes: ',queryData[i].id);
          tempUnsavedChanges[queryData[i].id].notes['obs'] = "";
        }*/
      }
      console.log('Obs: ', tempUnsavedChanges[queryData[i].id].notes.obs);
      if (!tempUnsavedChanges[queryData[i].id].notes.obs) {
        console.log('Init notes obs for: ',queryData[i].id);
        tempUnsavedChanges[queryData[i].id].notes.obs = "";
      }
    }
    this.setState({
      unsavedChanges: tempUnsavedChanges
    });
    console.log('Init Unsaved Changes')
    console.log(this.state.unsavedChanges);
  }

  storeUnsavedChanges(sampleId, fieldId, value) {
    console.log('storeUnsavedChanges');
    console.log('sampleId: ', sampleId, 'fieldId: ', fieldId, 'value: ', value);
    var tempUnsavedChanges = this.state.unsavedChanges;
    tempUnsavedChanges[sampleId].grades[fieldId] = value;
    this.setState({
      unsavedChanges: tempUnsavedChanges
    });
    console.log(tempUnsavedChanges);
    console.log(this.state.unsavedChanges);
  }

  storeUnsavedNotes(sampleId, fieldId, notesState) {
    var tempUnsavedChanges = this.state.unsavedChanges;
    tempUnsavedChanges[sampleId].notes[fieldId] = notesState;
    this.setState({
      unsavedChanges: tempUnsavedChanges
    });
    console.log('storeUnsavedNotes');
    console.log(tempUnsavedChanges);
    console.log(this.state.unsavedChanges);
  }

  saveToDb(sampleId) {
    this.props.dbRef.doc(sampleId).update(
      this.state.unsavedChanges[sampleId]
    )
    .then(docRef => {
      console.log('Saved succesfully.');
      console.log(docRef);
      //console.log('An offer was written with id: ' + docRef);
    })
    .catch(error => {
      console.log(error);
    });
  }

  handleRemove(sampleId) {
    if (window.confirm('Deseja realmente excluir a amostra?')) {
        this.props.dbRef.doc(sampleId).delete()
        .then(() => {
          let tempUnsavedChanges = this.state.unsavedChanges;
          delete tempUnsavedChanges[sampleId];
          console.log("deleted samples");
          console.log(tempUnsavedChanges);
          console.log(this.state.unsavedChanges);
          this.setstate({
            unsavedChanges: tempUnsavedChanges
          });
          console.log("Document successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
    }

  }

  componentWillUnmount() {
    var unsubscribe = this.props.dbRef.onSnapshot(() => {});
    unsubscribe();
  }

  render() {

    if (this.state.queryData) {
      var mySamples = this.state.queryData.map((sample, index) => {
        let sampleName;
        //console.log(sample.data());
        if (sample.data().name) {
          sampleName = sample.data().name;
        } else {
          sampleName = sample.id;
        }
        return (
          <li key={sample.id} onClick={() => {this.toggleContractInfo(index)}} >
            {sampleName}

            <span
              className="item-remove"
              onClick={() => {this.handleRemove(sample.id)}}>
              &times;
            </span>

          </li>
        );
      });
    } else {
      var mySamples = '';
    }


    return (
    <div>
      <h3>{this.props.name}</h3>
      <input type="button" value="Create Session" onClick={this.createNewCuppingSession}/>
      <Modal
        handleClose={this.handleCloseModal}
        showModal={this.state.showModal}
      >
        <h3>New Cupping Session</h3>
        <AddNewCuppingSessionForm
          saveSession={this.handleSaveSession}
          dbRef={this.props.dbRef}/>
      </Modal>
      <div className="col-25 basicforms">
        <ul>
          {mySamples}
        </ul>
      </div>
      <div className="col-75">
        {this.state.showInfo &&
          <SampleGradingForm
            dbRef={this.props.dbRef.doc(this.state.queryData[this.state.currentItem].id)}
            name={'Cupping Form - Sample ' + this.state.queryData[this.state.currentItem].data().name}
            sampleId={this.state.queryData[this.state.currentItem].id}
            formState={this.state.unsavedChanges[this.state.queryData[this.state.currentItem].id]}
            handleChange={this.storeUnsavedChanges}
            handleSaveNotes={this.storeUnsavedNotes}
            handleSubmit={this.saveToDb}
          />
        }
      </div>

    </div>

    );
  }
}

export default SamplesGrid;



// WEBPACK FOOTER //
// ./src/components/SamplesGrid.js